import { gql } from '@apollo/client';

export const GET_ENTITLEMENTS = gql`
  query wGetEntitlements($ecomToken: String!) {
    wGetEntitlements(ecomToken: $ecomToken)
  }
`;

export type GET_ENTITLEMENTS_VARIABLES = {
  ecomToken: string;
};

export enum EntitlementStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  REVOKED = 'REVOKED',
}

export type Entitlement = {
  id: string;
  sku: string;
  status: EntitlementStatus;
  entitlementStartDate: string;
  entitlementEndDate: string;
  termDays: number;
  entitlementSystemUri: string;
};

export type EntitlementsSuccessResult = {
  status: 'OK';
  entitlements: Entitlement[];
};

export type EntitlementsErrorResult = {
  status: 'OK';
  entitlements: {
    message: string;
  };
};

export type ViaxUserNotFoundErrorResult = {
  status: 'ERROR';
  errors: { message: string }[];
};

export interface GET_ENTITLEMENTS_RESPONSE {
  wGetEntitlements: {
    result:
      | EntitlementsSuccessResult
      | EntitlementsErrorResult
      | ViaxUserNotFoundErrorResult;
  };
}
